import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// material-ui
import { Box, List, Typography } from '@mui/material';

// project import
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const menu = useSelector((state) => state.menu);
  const userStore = useSelector((state) => state.userStore);
  // console.log(userStore?.access?.TAB_SETTINGS);
  // console.log(userStore.role);

  const { drawerOpen } = menu;
  // console.log(menu.openItem[0]);
  localStorage.setItem("activeMenu", menu.openItem[0]);

  const navCollapse = item.children?.map((menuItem) => {
    // console.log(item);
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        if (menuItem.id == 'userSettings') {
          if (userStore?.access?.TAB_SETTINGS) {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        }
        else if (menuItem.id == 'Report') {
          if (userStore?.access?.TAB_REPORT) {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        }
        else if (menuItem.id == 'Presentation') {
          if (userStore?.config?.TAB_PRESENTATION &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        } else if (menuItem.id == 'Templates') {
          if (userStore?.config?.TAB_TEMPLATE &&
            userStore.role !== "TESTER" &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        } else if (menuItem.id == 'Component') {
          if (userStore?.config?.TAB_COMPONENTS &&
            userStore.role !== "TESTER" &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        } else if (menuItem.id == 'Imports') {
          if (userStore?.config?.TAB_IMPORTS &&
            userStore.role !== "TESTER" &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        } else if (menuItem.id == 'NextConfigure') {
          if (userStore?.config?.TAB_DSPNEXTCONFIG &&
            userStore.role !== "TESTER" &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        } else if (menuItem.id == 'MigrationDSP') {
          if (userStore?.config?.TAB_DSP_MIGRATION &&
            // userStore.role !== "TESTER" &&
            userStore.role !== "NEW") {
            return <NavItem key={menuItem.id} item={menuItem} level={1} />;
          } else {
            return
          }
        }
        else {
          return <NavItem key={menuItem.id} item={menuItem} level={1} />;
        }

      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
